/** The payment-received screen, the receipt preview and the printed receipt's labels. */
export default {
  'receipt.paymentReceived': 'Payment received',
  'receipt.lastReceipt': 'Last receipt',
  'receipt.total': 'Total',
  'receipt.change': 'Change to return',
  'receipt.paidBy': 'Paid by',
  'receipt.printNext': 'Print & next customer',
  'receipt.reprint': 'Reprint copy',
  'receipt.noPrint': '{label}, no print',
  'receipt.nextCustomer': 'Next customer',
  'receipt.title': 'Receipt',
  'receipt.print': 'Print',
  'receipt.close': 'Close',
  'receipt.for': 'For {name}',
  'receipt.invoice': 'Invoice {number}',
  'receipt.saved': 'Customer saved',
  'receipt.whatsapp': 'WhatsApp the receipt to {phone}',
  'receipt.whatsappThanks': 'Thank you for shopping with us!',
  'receipt.whatsappThanksName': 'Thank you for shopping with us, {name}!',
  'receipt.reasonLabel': 'Reason for the copy (recorded in the audit log)',
  'receipt.reasonDefault': 'Customer asked for a duplicate',
  'receipt.printCopy': 'Print copy',
  'receipt.reprintRecorded': 'Reprint recorded in the audit log.',
  'receipt.reprintFailed': 'Could not record the reprint. Nothing was printed.',
  'receipt.printFailed': 'The receipt did not print: {error}.',
  'receipt.printerError': 'printer error',
  'receipt.preview': 'Receipt preview',
  'receipt.paperWidth': 'Paper width',
  'receipt.mm': '{width} mm',
  'receipt.summaryOnly': 'The server could not render the full receipt, so a summary is shown. Reprint it from the sale history.',

  'method.CASH': 'Cash',
  'method.UPI': 'UPI',
  'method.CARD': 'Card',
  'method.OTHER': 'Other',
  'method.NETBANKING': 'Net banking',
  'method.CHEQUE': 'Cheque',
  'method.WALLET': 'Wallet',
  'method.CREDIT': 'On credit',

  // printed receipt (the Tamil / bilingual HTML receipt)
  'rcpt.invoice': 'Invoice',
  'rcpt.date': 'Date',
  'rcpt.cashier': 'Cashier',
  'rcpt.customer': 'Customer',
  'rcpt.gstin': 'GSTIN',
  'rcpt.items': 'Items',
  'rcpt.gross': 'Gross',
  'rcpt.discount': 'Discount',
  'rcpt.noTax': 'No Tax',
  'rcpt.taxable': 'Taxable',
  'rcpt.gst': 'GST',
  'rcpt.roundOff': 'Round off',
  'rcpt.total': 'TOTAL',
  'rcpt.change': 'Change',
  'rcpt.taxExempt': 'TAX EXEMPT BILL',
  'rcpt.reprint': '*** REPRINT ***',
  'rcpt.thanks': 'Thank you. Visit again.',
} as const;
